import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
  ContainerErrorPageStyled,
  ContainerTitleStyled,
  ContainerButton,
  handleCommonNumberSx,
  handleCommonTitleSx,
  handleSubtitleSx,
  handleErrorButtonSx,
} from './styles/ErrorPageStyles';
import AtomButton from '../../components/atoms/AtomButton/AtomButton';
import AtomTypography from '../../components/atoms/AtomTypography/AtomTypography';
import Page from '../../components/template-minimal/Page';
import icons from '../../constants/icons';
import userAuth from '../../hooks/userAuth';
import { PATH_AUTH, PATH_DASHBOARD, PATH_DASHBOARD_STUDENT } from '../../routes/paths';
import { ContainerNumberIconStyled, EarthSearchStyled } from './Page404/styles/Page404Styles';
import { ROLE_ENUM } from '../Auth/Login/interfaces/IGoogleUser';

const ErrorPage404: React.FC = () => {
  const { auth } = userAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isLearner: boolean = auth?.userRole === ROLE_ENUM.STUDENT;
  const isAdvisor: boolean = auth?.userRole === ROLE_ENUM.ADMIN;
  const { t } = useTranslation('Page404');

  const goHomeClick = (): void => {
    if (isLearner) {
      navigate(PATH_DASHBOARD_STUDENT.admin.pageHome);
    } else if (isAdvisor) {
      navigate(PATH_DASHBOARD.admin.pageInsights);
    } else {
      navigate(PATH_AUTH.login);
    }
  };

  return (
    <Page title="404 Page Not Found">
      <ContainerErrorPageStyled>
        <ContainerNumberIconStyled>
          <AtomTypography fontWeight={400} sx={handleCommonNumberSx(theme)}>
            {t('NUMBER_4')}
          </AtomTypography>
          <EarthSearchStyled src={icons.EARTH_SEARCH_PAGE404} />
          <AtomTypography fontWeight={400} sx={handleCommonNumberSx(theme)}>
            {t('NUMBER_4')}
          </AtomTypography>
        </ContainerNumberIconStyled>
        <ContainerTitleStyled>
          <AtomTypography
            fontWeight={400}
            sx={{
              ...handleCommonTitleSx(theme),
              textAlign: 'center',
            }}
          >
            {t('TITLE_PAGE_404')}
          </AtomTypography>
          <AtomTypography fontWeight={700} sx={handleCommonTitleSx(theme)}>
            {t('BOLD_TITLE_PAGE_404')}
          </AtomTypography>
        </ContainerTitleStyled>
        <AtomTypography fontWeight={700} sx={handleSubtitleSx(theme)}>
          {t('SUBTITLE_PAGE_404')}
        </AtomTypography>
        <ContainerButton>
          <AtomButton onClick={goHomeClick} sx={handleErrorButtonSx(theme)}>
            {t('HOME_BUTTON_PAGE_404')}
          </AtomButton>
        </ContainerButton>
      </ContainerErrorPageStyled>
    </Page>
  );
};

export default ErrorPage404;
